<template>
  <b-button
    variant="info"
    @click="goTo"
  >
    <b-icon-flag
      class="mr-1" />
    ステータスの変更
  </b-button>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      modelName: 'users'
    }
  },

  methods: {
    goTo () {
      this.$router.push({
        name: `${this.modelName}-seating-status`,
        params: {
          id: this.id
        }
      })
    }
  }
}
</script>
